import React from "react";

const getCandybarItemLabel = (item, orderItem) => {
  const label = [item.name];

  item.configs.forEach(config => {
    if (config.id in orderItem) {
      const orderConfig = orderItem[config.id];
      config.options.forEach(option => orderConfig.indexOf(option.id) > -1 && label.push(option.name));
    }
  });

  return label.join(' + ');
};

function CandybarOrderSummary(props) {
    const items: JSX.Element[] = [];

    props.candybarOrder && Object.keys(props.candybarOrder)
        .forEach(itemId => {
            const item = props.candybarCatalog[itemId];
            const orderItem = props.candybarOrder[itemId];
            Object.keys(orderItem).forEach(unitId => {
                items.push(
                    <p className="mb-0" key={unitId}>
                        {getCandybarItemLabel(item, orderItem[unitId])}
                        {/* {orderItem[unitId].comments && (<React.Fragment> + <i className="fal fa-sticky-note" title={orderItem[unitId].comments}></i></React.Fragment>)} */}
                    </p>
                );
            });
        });

    if (!items.length) {
        return null;
    }

    return <>{items.map(item => item)}</>;
}

export default CandybarOrderSummary;